import Layout from "../components/utils/layout";
import Filters from "./filters";
import React from "react";
import Formatters from "../components/utils/formatters";
import NamedQueryModule from "../components/data_modules/named_query_module";


const RevenueViaFees = () => {
    const screenId="RevenueViaFees"
    const formatters = Formatters()
    const charts = {
        revenue_via_fees_summary: {},
        revenue_card_replacement_fees: {},
        revenue_transaction_level_view: {},
        revenue_gps_fees: {},
        revenue: {}

    }

    return <Layout prefsPrefix={screenId} items={charts}/>
}

export default RevenueViaFees
